const viewBox = document.querySelector('#viewImage')
const viewImages = viewBox?.querySelectorAll('img') 

function clearViewItemActive() {
    var items = document.querySelector('.view-list').children;
    for(var i = 0; i < items.length; i++)
        items[i].classList.remove('active');
}

function changeViewItem(item, itemName) {    
    clearViewItemActive();
    item.classList.toggle('active');

    viewImages.forEach(item => item.classList.add('hide'))
    viewBox.querySelector(`[data-view=${itemName}]`).classList.remove('hide')
}

// expose the fn in global scope for inline use
window.changeViewItem = changeViewItem